export type DistanceType = 'km' | 'kft' | 'm' | 'ns' | 'us' | 'ml';

export type MeaurementTypes = DistanceType;

export class Measurements {
    distance: DistanceType = 'km';
}
